var _jsxFileName = "/var/home/clovis/Documents/Mangane/app/soapbox/features/verification/steps/email-verification.tsx";
import React from 'react';
import { useIntl } from 'react-intl';
import snackbar from 'soapbox/actions/snackbar';
import { checkEmailVerification, postEmailVerification, requestEmailVerification } from 'soapbox/actions/verification';
import Icon from 'soapbox/components/icon';
import { Button, Form, FormGroup, Input, Text } from 'soapbox/components/ui';
import { useAppDispatch, useAppSelector } from 'soapbox/hooks';
const Statuses = {
  IDLE: 'IDLE',
  REQUESTED: 'REQUESTED',
  FAIL: 'FAIL'
};
const EMAIL_REGEX = /^[^@\s]+@[^@\s]+$/;
const EmailSent = ({
  handleSubmit
}) => {
  const dispatch = useAppDispatch();
  const checkEmailConfirmation = () => {
    dispatch(checkEmailVerification()).then(() => dispatch(postEmailVerification())).catch(() => null);
  };
  React.useEffect(() => {
    const intervalId = setInterval(() => checkEmailConfirmation(), 2500);
    return () => clearInterval(intervalId);
  }, []);
  return /*#__PURE__*/React.createElement("div", {
    className: "sm:pt-10 mx-auto flex flex-col items-center justify-center",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 39,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(Icon, {
    src: require('@tabler/icons/send.svg'),
    className: "text-primary-600 dark:text-primary-400 h-12 w-12 mb-5",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 40,
      columnNumber: 7
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "space-y-1 text-center mb-4",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 42,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement(Text, {
    weight: "bold",
    size: "3xl",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 43,
      columnNumber: 9
    }
  }, "We sent you an email"), /*#__PURE__*/React.createElement(Text, {
    theme: "muted",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 44,
      columnNumber: 9
    }
  }, "Click on the link in the email to validate your email.")), /*#__PURE__*/React.createElement(Button, {
    theme: "ghost",
    onClick: handleSubmit,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 47,
      columnNumber: 7
    }
  }, "Resend verification email"));
};
const EmailVerification = () => {
  const intl = useIntl();
  const dispatch = useAppDispatch();
  const isLoading = useAppSelector(state => state.verification.isLoading);
  const [email, setEmail] = React.useState('');
  const [status, setStatus] = React.useState(Statuses.IDLE);
  const [errors, setErrors] = React.useState([]);
  const isValid = email.length > 0 && EMAIL_REGEX.test(email);
  const onChange = React.useCallback(event => setEmail(event.target.value), []);
  const handleSubmit = React.useCallback(event => {
    event.preventDefault();
    setErrors([]);
    submitEmailForVerification();
  }, [email]);
  const submitEmailForVerification = () => {
    return dispatch(requestEmailVerification(email)).then(() => {
      setStatus(Statuses.REQUESTED);
      dispatch(snackbar.success(intl.formatMessage({
        id: 'email_verification.exists',
        defaultMessage: 'Verification email sent successfully.'
      })));
    }).catch(error => {
      const errorMessage = error.response?.data?.error;
      const isEmailTaken = errorMessage === 'email_taken';
      let message = intl.formatMessage({
        id: 'email_verification.fail',
        defaultMessage: 'Failed to request email verification.'
      });
      if (isEmailTaken) {
        message = intl.formatMessage({
          id: 'email_verification.exists',
          defaultMessage: 'This email has already been taken.'
        });
      } else if (errorMessage) {
        message = errorMessage;
      }
      if (isEmailTaken) {
        setErrors([intl.formatMessage({
          id: 'email_verification.taken',
          defaultMessage: 'is taken'
        })]);
      }
      dispatch(snackbar.error(message));
      setStatus(Statuses.FAIL);
    });
  };
  if (status === Statuses.REQUESTED) {
    return /*#__PURE__*/React.createElement(EmailSent, {
      handleSubmit: handleSubmit,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 108,
        columnNumber: 12
      }
    });
  }
  return /*#__PURE__*/React.createElement("div", {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 112,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "pb-4 sm:pb-10 mb-4 border-b border-gray-200 dark:border-gray-600 border-solid -mx-4 sm:-mx-10",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 113,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement("h1", {
    className: "text-center font-bold text-2xl",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 114,
      columnNumber: 9
    }
  }, intl.formatMessage({
    id: 'email_verification.header',
    defaultMessage: 'Enter your email address'
  }))), /*#__PURE__*/React.createElement("div", {
    className: "sm:pt-10 sm:w-2/3 md:w-1/2 mx-auto",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 117,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement(Form, {
    onSubmit: handleSubmit,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 118,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(FormGroup, {
    labelText: "Email Address",
    errors: errors,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 119,
      columnNumber: 11
    }
  }, /*#__PURE__*/React.createElement(Input, {
    type: "email",
    value: email,
    name: "email",
    onChange: onChange,
    placeholder: "you@email.com",
    required: true,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 120,
      columnNumber: 13
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "text-center",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 130,
      columnNumber: 11
    }
  }, /*#__PURE__*/React.createElement(Button, {
    block: true,
    theme: "primary",
    type: "submit",
    disabled: isLoading || !isValid,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 131,
      columnNumber: 13
    }
  }, "Next")))));
};
export default EmailVerification;